// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Home_mainHomeContainer__gLLve {
  min-height: calc(100vh - 160px);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 3rem;
  width: 100%;
  padding: 2rem;
  box-sizing: border-box;
}

.Home_homeimageIcon__dABQ5 {
  display: block;
  width: min(34vw, 420px);
  max-width: 100%;
  height: auto;
  object-fit: contain;
  flex-shrink: 0;
}

@media (max-width: 900px) {
  .Home_mainHomeContainer__gLLve {
    flex-direction: column;
    gap: 1.5rem;
    text-align: center;
  }

  .Home_homeimageIcon__dABQ5 {
    width: min(70vw, 340px);
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/Home/Home.module.css"],"names":[],"mappings":"AAAA;EACE,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,WAAW;EACX,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE;IACE,sBAAsB;IACtB,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,uBAAuB;EACzB;AACF","sourcesContent":[".mainHomeContainer {\n  min-height: calc(100vh - 160px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 3rem;\n  width: 100%;\n  padding: 2rem;\n  box-sizing: border-box;\n}\n\n.homeimageIcon {\n  display: block;\n  width: min(34vw, 420px);\n  max-width: 100%;\n  height: auto;\n  object-fit: contain;\n  flex-shrink: 0;\n}\n\n@media (max-width: 900px) {\n  .mainHomeContainer {\n    flex-direction: column;\n    gap: 1.5rem;\n    text-align: center;\n  }\n\n  .homeimageIcon {\n    width: min(70vw, 340px);\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"mainHomeContainer": `Home_mainHomeContainer__gLLve`,
	"homeimageIcon": `Home_homeimageIcon__dABQ5`
};
export default ___CSS_LOADER_EXPORT___;
